import { render, staticRenderFns } from "./RaffleSettingsComponent.vue?vue&type=template&id=15ffbb45&scoped=true"
import script from "./RaffleSettingsComponent.vue?vue&type=script&lang=js"
export * from "./RaffleSettingsComponent.vue?vue&type=script&lang=js"
import style0 from "./RaffleSettingsComponent.vue?vue&type=style&index=0&id=15ffbb45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ffbb45",
  null
  
)

export default component.exports